var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3759 8.00004C19.3759 8.29841 19.2574 8.58455 19.0464 8.79553C18.8354 9.00651 18.5493 9.12504 18.2509 9.12504H4.46964L9.29964 13.9541C9.51098 14.1654 9.62971 14.4521 9.62971 14.751C9.62971 15.0499 9.51098 15.3365 9.29964 15.5478C9.08829 15.7592 8.80165 15.8779 8.50276 15.8779C8.20388 15.8779 7.91723 15.7592 7.70589 15.5478L0.955887 8.79785C0.851007 8.69333 0.767791 8.56914 0.71101 8.4324C0.654228 8.29565 0.625 8.14904 0.625 8.00097C0.625 7.85291 0.654228 7.7063 0.71101 7.56955C0.767791 7.43281 0.851007 7.30862 0.955887 7.2041L7.70589 0.4541C7.81053 0.349453 7.93477 0.266442 8.0715 0.209807C8.20822 0.153173 8.35477 0.124023 8.50276 0.124023C8.65075 0.124023 8.7973 0.153173 8.93403 0.209807C9.07076 0.266442 9.19499 0.349453 9.29964 0.4541C9.40428 0.558747 9.4873 0.682981 9.54393 0.819709C9.60056 0.956437 9.62971 1.10298 9.62971 1.25097C9.62971 1.39897 9.60056 1.54551 9.54393 1.68224C9.4873 1.81897 9.40428 1.9432 9.29964 2.04785L4.46964 6.87504H18.2509C18.5493 6.87504 18.8354 6.99356 19.0464 7.20454C19.2574 7.41552 19.3759 7.70167 19.3759 8.00004Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/BackIcon.ec1031cf841ee4db3a8575bb3b187df2.svg";
export { ForwardRef as ReactComponent };